import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-score-bar-renderer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './score-bar-renderer.component.html',
  styleUrl: './score-bar-renderer.component.scss'
})
export class ScoreBarRendererComponent implements ICellRendererAngularComp {
    public score!: number;
    public class: string = '';

    agInit(params: ICellRendererParams): void {
      this.loadComponent(params);
    }
  
    refresh(params: ICellRendererParams): boolean {
      this.loadComponent(params);
      return true;
    }
  
  private loadComponent(params: ICellRendererParams) {
    const value = params.value as any;
    this.score = value?.value ?? params.value;
    this.class = (params as any).class || value?.class || '';
  }
}

